import React, { Component } from 'react';
import RestContextHOC from '../Contexts/RestContextHOC'
import UserContextHOC from '../Contexts/UserContextHOC'
import SignupModalContextHOC from '../Contexts/SignupModalContextHOC'
import AnalyticsContextHOC from '../Contexts/AnalyticsContextHOC'
import EntryPointHOC from '../Contexts/EntryPointHOC'
import Loading from '../Loading/Loading'
import './TaxExemptRequest.css'
const api = require('../helpers/api')

class TaxExemptRequest extends Component {

  constructor(props){
    super(props)
    this.state = {
      status: null,     // null=loading, 'approved', 'pending', 'form', 'submitted'
      submitting: false,
      error: null,
      email: '',
      first_name: '',
      last_name: '',
      organization: '',
      organization_tax_id: '',
      cert_link: ''
    }
    this.fileRef = React.createRef()
  }

  componentDidMount(){
    this.checkStatus()
  }

  componentDidUpdate(prevProps){
    // the diner can sign in from this page -- re-check their status and
    // prefill once the user context arrives
    if(!prevProps.user.user && this.props.user.user){
      this.setState({status:null})
      this.checkStatus()
    }
  }

  checkStatus(){
    if (!this.props.rest.rest_id){
      window.setTimeout(()=>this.checkStatus(), 200)
      return
    }
    if (!this.props.user.user){
      this.setState({status:'form'})
      return
    }
    let user = this.props.user.user
    this.setState({
      email: user.email || '',
      first_name: user.first_name || '',
      last_name: user.last_name || ''
    })
    api.callApi(
      'tax-exempt-request-status',
      (res)=>{
        if (res.approved) this.setState({status:'approved'})
        else if (res.pending) this.setState({status:'pending'})
        else this.setState({status:'form'})
      },
      (err)=>{ this.setState({status:'form'}) },
      {
        diner_uuid: user.uniq_uuid,
        rest_uuid: this.props.rest.rest_id
      }
    )
  }

  backToMenu(){
    this.props.analytics.info('ClickCloseTaxExemptRequest')
    this.props.history.push({
      pathname: '/menu',
      search: window.location.search
    })
  }

  submit(){
    if (this.state.submitting) return
    let file = this.fileRef.current && this.fileRef.current.files[0]
    if (file && file.size > 10 * 1024 * 1024){
      this.setState({error:'File is too large (10MB max)'})
      return
    }
    if (!this.state.email || !this.state.first_name ||
        !this.state.last_name || !this.state.organization ||
        !this.state.organization_tax_id){
      this.setState({error:'Please fill in all required fields'})
      return
    }
    if (!file && !this.state.cert_link.trim()){
      this.setState({error:
        'Please upload your tax-exemption form or provide a link to it'})
      return
    }
    this.setState({submitting:true, error:null})
    let form = new FormData()
    form.append('diner_uuid', this.props.user.user.uniq_uuid)
    form.append('rest_uuid', this.props.rest.rest_id)
    form.append('email', this.state.email)
    form.append('first_name', this.state.first_name)
    form.append('last_name', this.state.last_name)
    form.append('organization', this.state.organization)
    form.append('organization_tax_id', this.state.organization_tax_id)
    form.append('cert_link', this.state.cert_link)
    if (file) form.append('cert', file)
    fetch(`${window.API_HOST}/api/tax-exempt-request`, {
      method: 'post',
      body: form
    })
      .then(res => res.json())
      .then(json => {
        if (json.success){
          this.props.analytics.info('TaxExemptRequestSubmitted')
          this.setState({status:'submitted', submitting:false})
        } else {
          this.setState({
            error: json.error || 'Something went wrong. Please try again.',
            submitting: false
          })
        }
      })
      .catch(err => {
        this.setState({
          error: 'Something went wrong. Please try again.',
          submitting: false
        })
      })
  }

  renderMessage(text){
    return <div className='taxExemptMessage'>{text}</div>
  }

  restName(){
    return this.props.rest.name + (this.props.rest.secondary_name ?
      ' - ' + this.props.rest.secondary_name : '')
  }

  // name and email together, so the diner can see which account is approved
  // when they order under more than one
  dinerLabel(){
    let name = (this.state.first_name + ' ' + this.state.last_name).trim()
    if(name && this.state.email) return name + ' (' + this.state.email + ')'
    return name || this.state.email || 'Your account'
  }

  renderSignIn(){
    return (
      <div className='taxExemptMessage'>
        <p>
          You need an online ordering account to apply for tax-exempt
          ordering. Sign in (or create an account) using your organization's
          email address, then come back to this page.
        </p>
        <button
          className='taxExemptSubmit'
          onClick={()=>this.props.signupModal.openLogin('/tax-exempt')}
        >
          Sign In
        </button>
      </div>
    )
  }

  renderField(label, key, required, placeholder){
    return (
      <label className='taxExemptField'>
        <span className='taxExemptLabel'>
          {label}{required ? ' *' : ''}
        </span>
        <input
          value={this.state[key]}
          placeholder={placeholder || ''}
          onChange={(e)=>this.setState({[key]:e.target.value})}
        />
      </label>
    )
  }

  renderForm(){
    if (!this.props.user.user) return this.renderSignIn()
    return (
      <div className='taxExemptForm'>
        <p className='taxExemptIntro'>
          Apply for tax-exempt ordering
          at {this.props.rest.name}
          {this.props.rest.secondary_name ?
            ' - ' + this.props.rest.secondary_name : ''}. The
          restaurant will review your application. Once approved, you can
          mark eligible orders tax-exempt at checkout.
        </p>
        {this.renderField('Email address', 'email', true)}
        {this.renderField('First name', 'first_name', true)}
        {this.renderField('Last name', 'last_name', true)}
        {this.renderField('Organization name', 'organization', true)}
        {this.renderField('Organization tax ID', 'organization_tax_id', true)}
        <label className='taxExemptField'>
          <span className='taxExemptLabel'>
            Upload your tax-exemption form (PDF or image, 10MB max) *
          </span>
          <input type='file' ref={this.fileRef}
            accept='image/*,.pdf,.heic,.heif' />
        </label>
        {this.renderField('Or link your tax-exemption form', 'cert_link',
          false, 'https://')}
        <div className='taxExemptHint'>
          * A tax-exemption form is required — upload one or link to it.
        </div>
        {this.state.error && (
          <div className='taxExemptError'>{this.state.error}</div>
        )}
        <button
          className='taxExemptSubmit'
          disabled={this.state.submitting}
          onClick={()=>this.submit()}
        >
          {this.state.submitting ? 'Submitting...' : 'Submit Application'}
        </button>
      </div>
    )
  }

  renderContent(){
    if (this.state.status === null) return <Loading/>
    if (this.state.status === 'approved'){
      return this.renderMessage(
        <>
          <p>
            <b>{this.dinerLabel()}</b> is approved for tax-exempt ordering
            at {this.restName()}.
          </p>
          <p>
            To leave sales tax off an order, check the Tax Exempt box at
            checkout.
          </p>
        </>)
    }
    if (this.state.status === 'pending' || this.state.status === 'submitted'){
      return this.renderMessage(
        <>
          <p>
            The application for <b>{this.dinerLabel()}</b> is
            with {this.restName()} for review.
          </p>
          <p>
            Once they approve it, a Tax Exempt box appears at checkout.
          </p>
        </>)
    }
    return this.renderForm()
  }

  render() {
    return (
      <div className='taxExemptPage'>
        <div className='taxExemptCard'>
          <h2 className='taxExemptTitle'>
            Tax-Exempt Ordering
          </h2>
          {this.renderContent()}
          <div
            className='taxExemptBackLink'
            onClick={()=>this.backToMenu()}
          >
            Back to Menu
          </div>
        </div>
      </div>
    )
  }
}

export default AnalyticsContextHOC(EntryPointHOC(SignupModalContextHOC(
  UserContextHOC(RestContextHOC(TaxExemptRequest)))))
